import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface NotificationReadState {
  readIds: Set<string>;
  markRead: (id: string) => void;
  markAllRead: (ids: string[]) => void;
  isRead: (id: string) => boolean;
}

// Zustand persist needs plain serializable state; convert Set <-> array
interface PersistedState {
  readIdArray: string[];
}

export const useNotificationReadStore = create<NotificationReadState>()(
  persist(
    (set, get) => ({
      readIds: new Set<string>(),

      markRead: (id) => set((state) => ({ readIds: new Set([...state.readIds, id]) })),

      markAllRead: (ids) => set((state) => ({ readIds: new Set([...state.readIds, ...ids]) })),

      isRead: (id) => get().readIds.has(id),
    }),
    {
      name: 'notification-read-store',
      storage: createJSONStorage(() => localStorage),
      partialize: (state): PersistedState => ({
        readIdArray: [...state.readIds],
      }),
      merge: (persisted, current) => {
        const p = persisted as Partial<PersistedState>;
        return {
          ...current,
          readIds: new Set(p.readIdArray ?? []),
        };
      },
    },
  ),
);
